import React from 'react';
import SimpleClusteredMap from './SimpleClusteredMap';

/**
 * Simple test page to demonstrate marker clustering functionality
 */
const TestClusteringPage = () => {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <div style={{ height: '50px', background: '#4a4a4a', color: 'white', display: 'flex', alignItems: 'center', padding: '0 20px' }}>
        <h2>SafeHer Map - Clustering Test</h2>
      </div>
      <div style={{ height: 'calc(100% - 50px)', width: '100%' }}>
        <SimpleClusteredMap />
      </div>
    </div>
  );
};

export default TestClusteringPage;
